<app-onb-moldura passo="loja" [estado]="estado" [subtitulo]="etapaAtual.subtitulo">

  <div class="pl-etapas" role="tablist" aria-label="Partes deste passo">
    <button type="button" class="pl-etapa" *ngFor="let e of etapas; let i = index" role="tab" [attr.aria-selected]="i === indice"
            [class.atual]="i === indice" [class.feita]="i < indice && !pendenciaDa(e.id)" (click)="vaPara(i)">
      <span class="pl-etapa-n"><i class="fas fa-check" *ngIf="i < indice && !pendenciaDa(e.id); else numeroDaEtapa"></i><ng-template #numeroDaEtapa>{{ i + 1 }}</ng-template></span>
      <span class="pl-etapa-nome">{{ e.nome }}</span>
    </button>
  </div>

  <div class="onb-grupo pl-primeiro" *ngIf="etapa === 'cara'">
    <!-- prévia do topo da loja: capa larga com o logo por cima, como o cliente vê -->
    <div class="pl-vitrine">
      <div class="pl-capa" [class.vazia]="!empresa?.capa">
        <img *ngIf="empresa?.capa" [src]="'/images/empresa/' + empresa.capa" alt="Capa da loja">
        <span *ngIf="!empresa?.capa"><i class="far fa-image"></i> Sem capa, o topo fica liso</span>
      </div>
      <div class="pl-identidade">
        <span class="pl-logo">
          <img *ngIf="empresa?.logo" [src]="'/images/empresa/' + empresa.logo" [alt]="'Logo de ' + (empresa?.nome || 'sua loja')">
          <span *ngIf="!empresa?.logo">{{ iniciais }}</span>
        </span>
        <b>{{ empresa?.nome }}</b>
      </div>
    </div>
    <div class="onb-linha pl-linha-imagem" id="onb-loja-logo">
      <div class="onb-tx">
        <b>Logo</b>
        <span>Aparece no topo do cardápio, nos pedidos e no link que você divulga.</span>
      </div>
      <button type="button" class="onb-btn onb-btn--sec" *ngIf="enviando !== 'logo'" (click)="abraEnvio('logo')">{{ empresa?.logo ? 'Trocar logo' : 'Enviar logo' }}</button>
      <button type="button" class="onb-btn onb-btn--link" *ngIf="enviando === 'logo'" (click)="enviando = null">Cancelar</button>
    </div>
    <div class="pl-upload pl-upload--logo" *ngIf="enviando === 'logo'">
      <p class="pl-aviso-img">Imagem quadrada, com pelo menos 300 × 300 px.</p>
      <app-upload-crop-imagem [objeto]="imagemNova" prop="logo" ratio="1" [minWidth]="300" [minHeight]="300" [widthExibir]="220"
                              [uploadUrl]="'/upload/imagem/logoempresa'" [semCabecalho]="true" [maiorPossivel]="true"
                              (onEnviou)="salveImagem('logo', $event)"></app-upload-crop-imagem>
    </div>

    <div class="onb-linha pl-linha-imagem">
      <div class="onb-tx">
        <b>Capa <span class="onb-pill">Opcional</span></b>
        <span>Imagem larga atrás do logo, como na prévia acima.</span>
      </div>
      <button type="button" class="onb-btn onb-btn--sec" *ngIf="enviando !== 'capa'" (click)="abraEnvio('capa')">{{ empresa?.capa ? 'Trocar capa' : 'Enviar capa' }}</button>
      <button type="button" class="onb-btn onb-btn--link" *ngIf="enviando === 'capa'" (click)="enviando = null">Cancelar</button>
    </div>
    <div class="pl-upload pl-upload--larga" *ngIf="enviando === 'capa'">
      <p class="pl-aviso-img">Imagem larga, deitada (4 por 1), com pelo menos 992 × 240 px. Uma foto do ambiente ou dos produtos fica ótima.</p>
      <app-upload-crop-imagem [objeto]="imagemNova" prop="capa" ratio="4" [resizeWidth]="1240" [minWidth]="992" [minHeight]="240"
                              [semCabecalho]="true" [maiorPossivel]="true" (onEnviou)="salveImagem('capa', $event)"></app-upload-crop-imagem>
    </div>
    <p class="pl-aviso" *ngIf="erroImagem">{{ erroImagem }}</p>

    <div class="onb-linha pl-linha-imagem">
      <div class="onb-tx">
        <b>Banners de destaque <span class="onb-pill">Opcional</span></b>
        <span>Imagens que passam no topo do cardápio: combo da semana, novidade, horário especial.</span>
      </div>
      <button type="button" class="onb-btn onb-btn--sec" *ngIf="!bannerNovo" (click)="abraNovoBanner()"><i class="fas fa-plus"></i> Adicionar banner</button>
      <button type="button" class="onb-btn onb-btn--link" *ngIf="bannerNovo" (click)="bannerNovo = null">Cancelar</button>
    </div>
    <div class="pl-banners" *ngIf="banners.length">
      <div class="pl-banner" *ngFor="let b of banners">
        <img [src]="'/images/empresa/' + b.linkImagem" [alt]="b.nome">
        <span>{{ b.nome }}</span>
        <button type="button" class="pl-banner-remover" (click)="removaBanner(b)" [attr.aria-label]="'Remover ' + b.nome"><i class="fas fa-times"></i></button>
      </div>
    </div>
    <div class="pl-upload pl-upload--larga" *ngIf="bannerNovo">
      <div class="onb-campo pl-banner-nome">
        <label for="onb-banner-nome">Nome do banner</label>
        <input class="onb-inp" id="onb-banner-nome" [(ngModel)]="bannerNovo.nome" maxlength="80" placeholder="Ex.: Combo da semana">
      </div>
      <p class="pl-aviso-img">Imagem larga, deitada (4 por 1), com pelo menos 992 × 240 px.</p>
      <div id="onb-banner-imagem">
        <app-upload-crop-imagem [objeto]="bannerNovo" prop="linkImagem" ratio="4" [resizeWidth]="1240" [minWidth]="992" [minHeight]="240"
                                [semCabecalho]="true" [maiorPossivel]="true" (onEnviou)="imagemDoBannerEnviada($event)"></app-upload-crop-imagem>
      </div>
      <img class="pl-banner-previa" *ngIf="bannerNovo.linkImagem" [src]="'/images/empresa/' + bannerNovo.linkImagem" alt="Prévia do banner">
      <button type="button" class="onb-btn onb-btn--link" *ngIf="bannerNovo.linkImagem" (click)="bannerNovo.linkImagem = null">Trocar imagem</button>
      <div class="onb-acoes" style="margin-top: 10px">
        <button type="button" class="onb-btn onb-btn--pri" (click)="salveBanner()">{{ salvandoBanner ? 'Salvando…' : 'Salvar banner' }}</button>
      </div>
      <p class="pl-aviso" *ngIf="erroBanner">{{ erroBanner }}</p>
    </div>
    <p class="pl-aviso" *ngIf="erroBanner && !bannerNovo">{{ erroBanner }}</p>
  </div>

  <ng-container *ngIf="etapa === 'recebe'">
    <div class="onb-grupo-rot">Como o cliente recebe <span class="pl-mia" *ngIf="operacaoDaMia"><i class="fas fa-magic"></i> Anotado pela Mia</span></div>
    <div class="onb-grupo" id="onb-loja-modos">
      <div class="onb-linha">
        <span class="onb-ic onb-ic--loja"><i class="fas fa-motorcycle"></i></span>
        <div class="onb-tx"><b>Entrega</b><span>Você leva até o cliente.</span></div>
        <label class="onb-sw"><input type="checkbox" id="onb-loja-delivery" [(ngModel)]="delivery" aria-label="Entrega"><span></span></label>
      </div>
      <div class="onb-linha">
        <span class="onb-ic onb-ic--loja"><i class="fas fa-shopping-bag"></i></span>
        <div class="onb-tx"><b>Retirada no balcão</b><span>O cliente busca na loja.</span></div>
        <label class="onb-sw"><input type="checkbox" id="onb-loja-retirada" [(ngModel)]="retirada" aria-label="Retirada"><span></span></label>
      </div>
      <div class="onb-linha" *ngIf="retirada">
        <span class="onb-ic onb-ic--loja"><i class="fas fa-utensils"></i></span>
        <div class="onb-tx"><b>Comer no local</b><span>O cliente pede pelo celular e come aí, na loja.</span></div>
        <label class="onb-sw"><input type="checkbox" id="onb-loja-local" [(ngModel)]="comerNoLocal" aria-label="Comer no local"><span></span></label>
      </div>
      <div class="onb-linha">
        <span class="onb-ic onb-ic--loja"><i class="far fa-calendar-alt"></i></span>
        <div class="onb-tx"><b>Pedido agendado</b><span>O cliente escolhe dia e hora, mesmo com a loja fechada.</span></div>
        <label class="onb-sw"><input type="checkbox" id="onb-loja-agendamento" [(ngModel)]="agendamento" aria-label="Pedido agendado"><span></span></label>
      </div>
    </div>

    <ng-container *ngIf="delivery">
      <div class="onb-grupo-rot">Entrega</div>
      <div class="onb-grupo">
        <div class="onb-linha">
          <div class="onb-tx"><b>Taxa única de entrega</b><span>Comece simples. Por bairro ou por distância você ajusta depois em Formas de entrega.</span></div>
        </div>
        <div class="onb-campos">
          <div class="onb-campo">
            <label for="onb-taxa">Taxa</label>
            <div class="onb-prefixo"><span>R$</span><input class="onb-inp" id="onb-taxa" [(ngModel)]="taxa" inputmode="decimal" placeholder="0,00"></div>
          </div>
          <div class="onb-campo">
            <label for="onb-tmin">Tempo de entrega, de</label>
            <div class="onb-sufixo"><input class="onb-inp" id="onb-tmin" [(ngModel)]="tempoMinimo" inputmode="numeric"><span>min</span></div>
          </div>
          <div class="onb-campo">
            <label for="onb-tmax">até</label>
            <div class="onb-sufixo"><input class="onb-inp" id="onb-tmax" [(ngModel)]="tempoMaximo" inputmode="numeric"><span>min</span></div>
          </div>
          <div class="onb-campo">
            <label for="onb-minimo">Pedido mínimo</label>
            <div class="onb-prefixo"><span>R$</span><input class="onb-inp" id="onb-minimo" [(ngModel)]="pedidoMinimo" inputmode="decimal" placeholder="opcional"></div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="retirada">
      <div class="onb-grupo-rot">Retirada</div>
      <div class="onb-grupo">
        <div class="onb-campos">
          <div class="onb-campo">
            <label for="onb-rmin">Fica pronto em, de</label>
            <div class="onb-sufixo"><input class="onb-inp" id="onb-rmin" [(ngModel)]="tempoRetiradaMinimo" inputmode="numeric"><span>min</span></div>
          </div>
          <div class="onb-campo">
            <label for="onb-rmax">até</label>
            <div class="onb-sufixo"><input class="onb-inp" id="onb-rmax" [(ngModel)]="tempoRetiradaMaximo" inputmode="numeric"><span>min</span></div>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="pl-previa" *ngIf="previa">
      <i class="far fa-eye"></i><span>O cliente vê: <b>{{ previa }}</b></span>
    </div>
  </ng-container>

  <div class="onb-grupo pl-primeiro" *ngIf="etapa === 'endereco'">
    <div class="onb-linha" *ngIf="manterEndereco">
      <span class="onb-ic onb-ic--neutro"><i class="fas fa-map-marker-alt"></i></span>
      <div class="onb-tx"><b>{{ enderecoSalvo }}</b><span>É daqui que o pedido sai e onde o cliente retira.</span></div>
      <button type="button" class="onb-btn onb-btn--sec" (click)="troqueEndereco()">Trocar</button>
    </div>
    <ng-container *ngIf="!manterEndereco">
      <div class="onb-campos">
        <div class="onb-campo">
          <label for="onb-cep">CEP</label>
          <div class="pl-cep">
            <input class="onb-inp" id="onb-cep" [(ngModel)]="cep" (input)="aoDigitarCep()" inputmode="numeric" maxlength="9" placeholder="00000-000">
            <button type="button" class="pl-buscar-cep" (click)="aoDigitarCep()"
                    [disabled]="buscandoCep || cep.split('-').join('').trim().length !== 8"
                    [attr.aria-label]="buscandoCep ? 'Buscando CEP' : 'Buscar CEP'" title="Buscar CEP">
              <i [class]="buscandoCep ? 'fas fa-spinner fa-spin' : 'fas fa-search'" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="onb-campo pl-rua">
          <label for="onb-rua">Rua</label>
          <input class="onb-inp" id="onb-rua" [(ngModel)]="rua" autocomplete="address-line1">
        </div>
        <div class="onb-campo">
          <label for="onb-numero">Número</label>
          <input class="onb-inp" id="onb-numero" [(ngModel)]="numero" placeholder="120 ou s/n">
        </div>
      </div>
      <div class="onb-campos">
        <div class="onb-campo"><label for="onb-compl">Complemento</label><input class="onb-inp" id="onb-compl" [(ngModel)]="complemento" placeholder="opcional"></div>
        <div class="onb-campo"><label for="onb-bairro">Bairro</label><input class="onb-inp" id="onb-bairro" [(ngModel)]="bairro"></div>
        <div class="onb-campo"><label for="onb-cidade">Cidade</label><input class="onb-inp" id="onb-cidade" [(ngModel)]="cidade"></div>
        <div class="onb-campo pl-uf"><label for="onb-uf">UF</label><input class="onb-inp" id="onb-uf" [(ngModel)]="uf" maxlength="2"></div>
      </div>
      <p class="pl-aviso" *ngIf="buscandoCep || avisoCep">{{ buscandoCep ? 'Buscando o CEP…' : avisoCep }}</p>
    </ng-container>
  </div>

  <div class="onb-grupo pl-primeiro" *ngIf="etapa === 'horario'">
    <div class="onb-linha">
      <span class="onb-ic onb-ic--neutro"><i class="far fa-clock"></i></span>
      <div class="onb-tx">
        <b>{{ resumoDoHorario }}</b>
        <span *ngIf="!editandoHorario">{{ estado?.horarios?.padrao ? 'Padrão para ' + estado?.horarios?.padrao + '. Se o seu é outro, mude aqui.' : 'Quando a loja aparece aberta para o cliente.' }}</span>
        <span *ngIf="editandoHorario">Vale quando você salvar.</span>
      </div>
      <button type="button" class="onb-btn onb-btn--sec" *ngIf="!editandoHorario" (click)="abraHorario()">Mudar</button>
      <button type="button" class="onb-btn onb-btn--link" *ngIf="editandoHorario" (click)="editandoHorario = false">Cancelar</button>
    </div>
    <div class="pl-horario" *ngIf="editandoHorario">
      <p class="pl-aviso-img" *ngIf="!estado?.horarios?.semana && estado?.horarios?.resumo !== 'Fechada todos os dias'">
        Hoje cada dia tem um horário. Escolhendo aqui, todos os dias marcados ficam iguais.
      </p>
      <div class="pl-modelos" id="onb-horario-modelos" role="radiogroup" aria-label="Horário da loja">
        <button type="button" class="pl-modelo" *ngFor="let m of modelos" role="radio" [attr.aria-checked]="modelo === m.id"
                [class.ativo]="modelo === m.id" (click)="escolhaModelo(m.id)">
          <b>{{ m.nome }}</b><span>{{ m.horas }}</span>
        </button>
      </div>
      <ng-container *ngIf="modelo === 'outro'">
        <div class="onb-campos pl-turno" *ngFor="let t of turnosOutro; let i = index">
          <div class="onb-campo">
            <label [for]="'onb-abre-' + i">{{ i ? 'Abre de novo às' : 'Abre às' }}</label>
            <input class="onb-inp" type="time" [id]="'onb-abre-' + i" [(ngModel)]="t.abre">
          </div>
          <div class="onb-campo">
            <label [for]="'onb-fecha-' + i">Fecha às</label>
            <input class="onb-inp" type="time" [id]="'onb-fecha-' + i" [(ngModel)]="t.fecha">
          </div>
        </div>
        <button type="button" class="onb-btn onb-btn--link" *ngIf="turnosOutro.length === 1" (click)="adicioneSegundoTurno()">
          <i class="fas fa-plus"></i> Segundo turno
        </button>
        <button type="button" class="onb-btn onb-btn--link" *ngIf="turnosOutro.length === 2" (click)="turnosOutro = [turnosOutro[0]]">
          Tirar o segundo turno
        </button>
      </ng-container>
      <div class="pl-rot-dias">Dias que a loja abre</div>
      <div class="pl-dias" id="onb-horario-dias">
        <button type="button" class="pl-dia" *ngFor="let d of diasDaSemana" [class.ativo]="diasAbertos.includes(d.dia)"
                [attr.aria-pressed]="diasAbertos.includes(d.dia)" (click)="alterneDia(d.dia)">{{ d.nome }}</button>
      </div>
      <a class="onb-btn onb-btn--link pl-dia-a-dia" routerLink="/admin/loja/tab/horarios">Horário diferente em cada dia? Ajustar dia a dia</a>
    </div>
  </div>

  <div class="onb-erro" *ngIf="erro">{{ erro }}</div>

  <div class="onb-rodape">
    <span class="onb-dica">{{ dica }}</span>
    <a class="onb-btn onb-btn--link" routerLink="/admin/comecar" *ngIf="!indice">Fazer depois</a>
    <button type="button" class="onb-btn onb-btn--link" *ngIf="indice" (click)="vaPara(indice - 1)"><i class="fas fa-chevron-left"></i> Voltar</button>
    <button type="button" class="onb-btn onb-btn--pri onb-btn--grande" (click)="avance()">
      {{ salvando ? 'Salvando…' : ultima ? 'Salvar e continuar' : 'Continuar' }}
    </button>
  </div>
</app-onb-moldura>
